/* MUI */
import { Box, CircularProgress, Typography } from '@mui/material';

/* Shared */
import { WORKATO_EMBEDDING_CLIENT_SCRIPT } from 'application/Shared/Constants/Workato';

/* Hooks */
import { useFetchEmbeddedCustomerInfo } from 'hooks/dataAccess/Workato/workato';

/* React */
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

const defaultHandleMessage = () => {};

export const WorkatoIFrame = ({ clientId, path, handleMessageFn }) => {
    const { t } = useTranslation();

    const [isScriptLoading, setIsScriptLoading] = useState(false);
    const [isEmbeddingClientConfigured, setIsEmbeddingClientConfigured] =
        useState(false);

    const location = useLocation();

    const workatoIFrameRef = useRef();

    const handleMessage = handleMessageFn || defaultHandleMessage;

    const { jwt, baseUrl, region, loading } =
        useFetchEmbeddedCustomerInfo(clientId);

    useEffect(() => {
        const script = document.createElement('script');

        if (region && !isScriptLoading && !isEmbeddingClientConfigured) {
            // window.Workato.off is a function that should be doing this but it doesn't
            // seem to be working
            if (window.Workato) {
                window.Workato.messageHandlers['*'] = [];
            }
            setIsScriptLoading(true);
            script.type = 'text/javascript';
            // https://docs.workato.com/oem/workato-embedded-implementation.html#workato-embedding-client
            script.setAttribute('src', WORKATO_EMBEDDING_CLIENT_SCRIPT[region]);
            script.addEventListener('load', () => {
                window.Workato.configure({
                    embeddingUrlPrefix: location.pathname
                });
                window.Workato.on('*', (message) => {
                    handleMessage(message);
                });
                setIsEmbeddingClientConfigured(true);
                setIsScriptLoading(false);
            });
            document.head.appendChild(script);
        }

        return () => {
            if (document.head.contains(script)) {
                document.head.removeChild(script);
            }
        };
    }, [
        handleMessage,
        isEmbeddingClientConfigured,
        isScriptLoading,
        location.pathname,
        region
    ]);

    return (
        <Box display="flex" justifyContent="center" minHeight="600px">
            {loading && <CircularProgress />}
            {!loading && isEmbeddingClientConfigured && (
                <iframe
                    ref={workatoIFrameRef}
                    id="workatoIframe"
                    src={`${baseUrl}/direct_link/embedded/${path}?workato_dl_token=${jwt}`}
                    title="Workato"
                    style={{ overflow: 'auto', width: '100%' }}
                />
            )}
            {!loading && !isEmbeddingClientConfigured && (
                <Typography>
                    {t('Integrations.saasOps.couldNotConnect')}
                </Typography>
            )}
        </Box>
    );
};
